export enum OnlineAppointmentStatus{
    COMPLETADA = 1,
    VENCIDA = 2,
    USUARIO_POR_REGISTRAR = 3,
    POR_COMPLETAR = 4
}